import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

export interface IAdjustmentOrganizationSubcategory {
	Name: string;
	Organization_ID: number;
	Organization_Subcategory_ID: number;
}

const initialState = new Array<IAdjustmentOrganizationSubcategory>();

export const { thunk: listAdjustmentOrganizationSubcategories, slice: listAdjustmentOrganizationSubcategoriesSlice } =
	getThunkAndSlice<Record<string, never>, typeof initialState>({
		initialState,
		path: "/api/Sales/ListAdjustmentOrganizationSubcategories",
	});
